import { useState, useEffect } from 'react'
import {
  GUEST_ACQUISITION_HERO_IMAGE,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useHeroImageVariant(): {
  isVariant: boolean
  isLoaded: boolean
  setIsLoaded: (loaded: boolean) => void
} {
  const [isLoaded, setIsLoaded] = useState(false)

  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ACQUISITION_HERO_IMAGE,
    true,
  )

  const variantsMap = {
    [OPTIMIZELY_VARIANT_KEYS.HERO_IMAGE_VISIBLE_VARIANT]: 'variant',
    [OPTIMIZELY_VARIANT_KEYS.HERO_IMAGE_VISIBLE_CONTROL]: 'control',
  }

  const heroImageEnabled = [
    OPTIMIZELY_VARIANT_KEYS.HERO_IMAGE_VISIBLE_VARIANT,
    OPTIMIZELY_VARIANT_KEYS.HERO_IMAGE_VISIBLE_CONTROL,
  ].includes(decisionObj?.variationKey)

  // Update isLoaded state based on decisionObj availability
  useEffect(() => {
    if (decisionObj !== null) {
      setIsLoaded(true)
    } else {
      setTimeout(() => {
        setIsLoaded(true)
      }, 500)
    }
  }, [decisionObj])

  return {
    isVariant: heroImageEnabled
      ? variantsMap[decisionObj?.variationKey] === 'variant'
      : false,
    isLoaded,
    setIsLoaded,
  }
}
